import { connect } from 'react-redux';
import { selectors, actions, constants } from '@amplement/backend-connector';

import { getRoomFeatures } from 'selectors/room';
import IncomingCall from './index';

type OwnProps = {
    _room?: string;
}

const mapStateToProps = (state: any, ownProps: OwnProps) => {
    const { avatarUri, title, fullname, displayablePhonenumber, isCrmData, url, source, transferredFrom } = selectors.rooms.getRoomInitiatorByRoomIdSelector(state, ownProps?._room) || {};
    const members = selectors.rooms.getUniqRoomMembersWithoutMeOrCallerByRoomIdSelector(state, ownProps?._room) || {};
    const features = getRoomFeatures(state, ownProps?._room);

    return ({
        avatarUri,
        description: title,
        callerName: fullname,
        transferredFrom,
        callerPhoneNumber: displayablePhonenumber,
        isCrmData,
        url,
        source,
        roomType: selectors.rooms.getRoomTypeByRoomIdSelector(state, ownProps?._room),
        members,
        transferToPhonenumber: features?.transferToPhonenumber,
        hasFastReply: !!features?.displayFastReply
    });
};

const mapDispatchToProps = dispatch => ({
    onAccept: (_room:string, kind: string = constants.rooms.ROOM_TYPE.VIDEO) =>
        dispatch(actions.rooms.acceptIncoming(_room, true, kind === constants.rooms.ROOM_TYPE.VIDEO, false)),
    onReject: (_room:string) => dispatch(actions.rooms.rejectIncoming(_room)),
    onIgnore: (_room:string) => dispatch(actions.rooms.ignoreIncoming(_room)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IncomingCall);
